import React, { useContext } from "react";
import { FaChair, FaRunning, FaDiagnoses, FaTools } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./erg.png";

const Ergonomics: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/ergonomics');
    } else {
      navigate('/login', { state: { from: '/booking/ergonomics' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Health Safety</span>
          <h1 className="hero-title">Workplace Ergonomics</h1>
          <p className="hero-subtitle">
            Fitting the job to the worker, not the worker to the job.
            Prevent musculoskeletal disorders and boost productivity through smart design.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Science of Comfort</h2>
              <p className="article-text">
                Ergonomics is about designing for human physiology. It minimizes physical stress
                and maximizes efficiency. Ignoring ergonomics leads to Repetitive Strain Injuries (RSIs),
                back pain, and long-term disability.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Neutral Posture</h2>
              <p className="article-text">
                The body is strongest and most efficient in its neutral position.
                <strong>Sitting:</strong> Feet flat, knees at 90°, lower back supported.
                <strong>Standing:</strong> Head aligned with spine, work at elbow height.
                Deviating from neutral creates static load on muscles.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Manual Handling Tips</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Power Zone:</strong> Lift between knees and shoulders.</li>
                  <li><strong>Use Legs:</strong> Never lift with your back.</li>
                  <li><strong>No Twisting:</strong> Turn your feet, not your torso.</li>
                  <li><strong>Get Help:</strong> Use mechanical aids for heavy loads.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Preventing "Tech Neck"</h2>
              <p className="article-text">
                Looking down at screens for hours exerts 60lbs of force on the cervical spine.
                Raise your monitor to eye level. Take "micro-breaks" every 30 minutes to stretch
                and refocus your eyes (20-20-20 rule).
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Ergo Checklist</h4>
              <ul className="key-list">
                <li><FaChair className="check-icon" /> Adjustable Seating</li>
                <li><FaRunning className="check-icon" /> Dynamic Movement</li>
                <li><FaDiagnoses className="check-icon" /> Early Symptom Reporting</li>
                <li><FaTools className="check-icon" /> Mechanical Aids</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Work Smarter</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Comfort equals productivity. Learn the basics.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Ergonomics;
